<template>
  <transition name="toggle-filters">
    <div class="media-library__filters media-library__filters--mobile" v-if="mobileFiltersOpen">
      <header class="media-library__filters-header">
        <button
            class="btn btn--close"
            aria-label="Sluit filters"
            @click="closeFilters"
        >
          <svg class="icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="28" height="28"
               viewBox="0 0 28 28" aria-hidden="true" focusable="false">
            <title>close</title>
            <path
                d="M28 2.83L25.17 0 14 11.17 2.83 0 0 2.83 11.17 14 0 25.17 2.83 28 14 16.83 25.17 28 28 25.17 16.83 14z" />
          </svg>
        </button>
        <h2>Filteren</h2>
      </header>
      <div class="filter-block" v-for="filterGroup in filters" :key="filterGroup.id">
        <h3 v-html="filterGroup.title" />
        <ul>
          <li v-for="filter in filterGroup.items" :key="filter.id" class="checkbox-small">
            <input
                type="checkbox"
                :id="filter.id"
                :checked="filter.isActive"
                @change="changeFilter(filter)"
            >
            <label :for="filter.id" v-html="filter.name" />
          </li>
        </ul>
      </div>
      <button
          @click="closeFilters"
          class="btn btn--1"
          v-if="activeFilters.length > 0"
          v-html=" settings.filtersApply" />
      <button
          @click="clearFilters"
          class="btn btn--2"
          v-if="activeFilters.length > 0"
          v-html="settings.filtersReset" />
    </div>
  </transition>
</template>

<script setup>
defineProps( {
  filters: {
    type: Array,
    required: true
  },
  mobileFiltersOpen: {
    type: Boolean,
    required: true
  },
  activeFilters: {
    type: Array,
    required: true
  },
  settings: {
    type: Object,
    required: true
  }
} );

const emit = defineEmits( [ 'filterChanged', 'closeFilters', 'clearFilters' ] );

const changeFilter = ( filter ) => emit( 'filterChanged', filter );
const closeFilters = () => emit( 'closeFilters' );
const clearFilters = () => emit( 'clearFilters' );
</script>
